import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, Timer, Activity, FlaskConical, Heart, Brain } from 'lucide-react';
import { TOKENS, displayFont } from '../../lib/designTokens';

// CRO Audit §5.3 step 6 — Tools strip. Interactive value, lead-gen ramp.
const TOOLS = [
  { id: 'longevity', label: 'Longevity Score', href: '/tools/longevity-score', icon: Heart },
  { id: 'race', label: 'HYROX Predictor', href: '/tools/race-plan', icon: Timer },
  { id: 'recomp', label: 'Body Recomp', href: '/tools/body-recomp', icon: Activity },
  { id: 'cycle', label: 'Cycle Tracker', href: '/tools/peptide-cycle-tracker', icon: FlaskConical },
  { id: 'biohacking', label: 'Biohacking Score', href: '/tools/biohacking-score', icon: Brain },
  { id: 'all', label: 'All Calculators', href: '/tools', icon: Calculator },
];

export const ToolsStrip = () => (
  <section
    className="py-16 md:py-20"
    style={{ backgroundColor: TOKENS.surface1, borderTop: '1px solid rgba(255,255,255,0.05)' }}
    data-testid="tools-strip-section"
  >
    <div className="container-ninja">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <p
            className="text-[11px] uppercase tracking-[0.25em] mb-2"
            style={{ color: TOKENS.lime, ...displayFont }}
          >
            Free · No signup to start
          </p>
          <h2
            className="text-white text-2xl md:text-3xl"
            style={displayFont}
          >
            Run the numbers
          </h2>
        </div>
        <p className="text-zinc-500 text-sm max-w-md">
          Quick interactive calculators — save your results to your inbox when you&apos;re done.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {TOOLS.map((tool) => {
          const Icon = tool.icon;
          return (
            <Link
              key={tool.id}
              to={tool.href}
              className="group flex flex-col items-start gap-3 p-5 transition-all duration-300 hover:-translate-y-0.5"
              style={{
                backgroundColor: TOKENS.surface2,
                border: '1px solid rgba(255,255,255,0.06)',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = TOKENS.limeBorder; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'; }}
              data-testid={`tools-strip-${tool.id}`}
            >
              <Icon className="w-5 h-5" style={{ color: TOKENS.lime }} strokeWidth={1.5} />
              <span
                className="text-white text-sm leading-tight group-hover:text-[#C7FA3E] transition-colors"
                style={displayFont}
              >
                {tool.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);
